import ConsentPromptContent from './ConsentPromptContent'

export default ConsentPromptContent
